import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/host/stores/auth.store';

const getOrgSlugFromPath = (pathname: string): string | null => {
  const match = /^\/([^/]+)/.exec(pathname);
  return match ? match[1] : null;
};

export const GuestAuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('isUserGuest');

  const { signOut } = useAuthStore.getState();

  const location = useLocation();
  const orgSlug = getOrgSlugFromPath(location.pathname);
  const welcomeRedirect = orgSlug ? `/${orgSlug}/welcome` : '/login';

  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const verify = async () => {
      // For guests, only check if token exists (don't check expiration)
      // The API interceptor will handle token refresh automatically
      // If refresh token is also expired, the interceptor will handle logout
      const valid = !!token;
      if (!valid) {
        await signOut();
        setAuthenticated(false);
      } else {
        setAuthenticated(true);
      }
      setChecking(false);
    };
    verify();
  }, [token, signOut]);

  if (checking) return <div>Loading...</div>;

  if (!authenticated) {
    return <Navigate to={welcomeRedirect} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
